import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

// Components
import Navbar from "./components/NavBar";
import Footer from "./components/Footer";
import About from "./components/About";
import ProductGrid from "./components/ProductGrid";
import ProductDetails from "./components/ProductDetails";
import LandingPage from "./components/LandingPage";
import SubmitQuoteForm from "./components/SubmitQuoteForm";
import AuthScreen from "./components/AuthScreen";
import Faq from "./components/Faq";
import Ifu from "./components/Ifu";
import CertificatesPage from "./components/CertificatesAndLicensing";
import LoginScreen from "./components/LoginScreen";
import SearchPage from "./components/SearchPage"; // Import SearchPage component
import NotFound from "./components/NotFound";
import Fittings from "./components/Fittings";
import Breadcrumbs from "./components/Breadcrumbs"; // Import Breadcrumbs component
import Ems from "./components/Ems";
import ScrollToTop from "./components/ScrollToTop";
import Sitemap from "./components/Sitemap.js";

// Styles
import "./App.css";

// Products Data
const products = [
  { id: 1, name: "Flowmeter", price: 29.99, image: "TESTDEMO/flowmeter2.jpg" },
  { id: 2, name: "Regulators", price: 49.99, image: "TESTDEMO/P-DR8133.png" },
  { id: 4, name: "Mass Casuality", price: 99.99, image: "TESTDEMO/masscass1.png" },
  { id: 5, name: "Transfill Cascade System", price: 59.99, image: "TESTDEMO/transfillcascade.png" },
  { id: 6, name: "Fittings / Accessories / Replacement Parts", price: 39.99, image: "TESTDEMO/fittings.png" },
  { id: 7, name: "EMS", price: 39.99, image: "TESTDEMO/Ambulance-remove-bg.png" },
  { id: 8, name: "Hose Assemblies", price: 39.99, image: "TESTDEMO/HoseAssembly/hose-removed-bg.png" },
];

const App = () => {
  const excludedRoutes = ["/signup", "/login"];
  const breadcrumbRoute = ["/"];
  const location = useLocation();
  const isExcludedRoute = excludedRoutes.includes(location.pathname);
  const isExcludedBreadcrumbRoute = breadcrumbRoute.includes(location.pathname);

  return (
    <div className="layout-wrapper">
      {!isExcludedRoute && <Navbar />}

      <div className="main-content-wrapper">
        {!isExcludedBreadcrumbRoute && <Breadcrumbs />} {/* ← Show Breadcrumbs only on allowed routes */}

        <main className="main-content">
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/products" element={<ProductGrid products={products} isSearchPage={false} />} />
            <Route path="/products/:id" element={<ProductDetails products={products} />} />
            <Route path="/products/fittings" element={<Fittings />} />
            <Route path="/products/ems" element={<Ems />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<SubmitQuoteForm />} />
            <Route path="/signup" element={<AuthScreen />} />
            <Route path="/login" element={<LoginScreen />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/certs" element={<CertificatesPage />} />
            <Route path="/ifu" element={<Ifu />} />
            <Route path="/ifu/:id" element={<Ifu />} />
            <Route path="/sitemap" element={<Sitemap />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
      </div>

      {!isExcludedRoute && <Footer />}
    </div>

  );
};

export default App;
